export default {"src":"/_next/static/image/public/img/logo.84141e562d495f1de1d038f76ac84fd0.svg","height":90,"width":149};